const initialState = {
    defUser: null,
    api: null
};

export default function conf(state = initialState, action) {
    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/conf.js